// Mobile (<768px) uses 16px input font-size to prevent iOS Safari auto-zoom
// on focus. Desktop (md+) keeps the original text sizes. Small variant also
// bumps its height on mobile so 16px text doesn't look cramped in a 28px
// container; medium and large keep their desktop heights.
export const SIZE_CONFIG = {
  small: {
    group: "h-8 md:h-7",
    input: "text-base md:text-xs px-2",
    addonStart: "ps-1.5",
    addonEnd: "pe-1.5",
    icon: "size-3.5",
  },
  medium: {
    group: "h-8",
    input: "text-base md:text-sm",
    addonStart: "ps-2",
    addonEnd: "pe-2",
    icon: "size-4",
  },
  large: {
    group: "h-10",
    input: "text-base md:text-sm",
    addonStart: "ps-2.5",
    addonEnd: "pe-2.5",
    icon: "size-5",
  },
};
